import { render } from "./HandleIcon.vue?vue&type=template&id=486018a2&ts=true"
import script from "./HandleIcon.vue?vue&type=script&lang=ts"
export * from "./HandleIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__